import * as React from 'react';

import { useGetInfoCardProps } from './utils/useGetInfoCardProps';
import { InfoCard } from '../../components/InfoCard';

export function InfoCardContainer() {
  const props = useGetInfoCardProps();

  return (
    <>
      <InfoCard isReversed {...props} />
      <InfoCard
        role="salesman"
        title="Продавцу"
        text="Укажите в объявлении цену в диапазоне оценки и получите значок «Хорошая цена» — это привлечёт больше внимания"
      />
    </>
  );
}
